import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles';
import classNames from 'classnames';
import Drawer from 'material-ui/Drawer';
import Divider from 'material-ui/Divider';
import IconButton from 'material-ui/IconButton';
import AppsIcon from 'material-ui-icons/Apps';
import {connect} from 'react-redux';
import {toggleSideBar} from './actions';
import styles from './style/side_menu';
import MainAppBar from './app_bar';
import MainMenu from './main_menu';

class PageTop extends React.Component {

    handleDrawerClose = () => {
        this.props.toggleSideBar(false);
    };

    render() {
        const classes = this.props.classes;

        const sidebarClasses = {
            paper: classNames(
                classes.drawerPaper,
                !this.props.sidebarOpen && classes.drawerPaperClose
            ),
            docked: classNames(
                classes.drawerPaperDocked
            )
        };

        const logoClasses = classNames(
            this.props.sidebarOpen && classes.logo,
            !this.props.sidebarOpen && classes.hide
        );

        const iconAppsButtonClasses = classNames(
            classes.menuButtonIcons,
            !this.props.sidebarOpen && classes.hide
        );

        let appBar = classNames(classes.appBar, this.props.sidebarOpen && classes.appBarShift);
        let toolBar = classNames(classes.logo, this.props.sidebarOpen && classes.hide);
        let iconButton = classNames(classes.menuButton, this.props.sidebarOpen && classes.hide);

        const iconActiveBorder = classNames(
            !this.props.sidebarOpen && "iconActiveBorder",
        );

        if (!this.props.authenticated) {
            return null;
        } else {
            return (
                <div>
                    <MainAppBar appBar={appBar} toolBar={toolBar} iconButton={iconButton}/>
                    <Drawer variant="permanent" classes={sidebarClasses} open={this.props.sidebarOpen}>
                        <div className={classes.drawerInner}>
                            <div className={classes.drawerHeader}>
                                <IconButton onClick={this.handleDrawerClose} className={iconAppsButtonClasses}>
                                    <AppsIcon/>
                                </IconButton>
                                <div className={logoClasses}>
                                    <div className="logo-SideMenu">
                                        <img src={process.env.PUBLIC_URL + '/assets/logo.svg'} alt="logo" />
                                    </div>
                                </div>
                            </div>
                            <Divider/>
                            <MainMenu iconActiveBorder={iconActiveBorder}/>
                        </div>
                    </Drawer>
                </div>
            );
        }
    }
};

PageTop.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    authenticated: state.auth.authenticated,
    userName: state.auth.user.name,
    sidebarOpen: state.layout.sidebarOpen,
    showLoader: state.layout.ajaxCallsInProgress > 0,
});

export default connect(mapStateToProps, {toggleSideBar})(
    withStyles(styles)(PageTop)
);



// WEBPACK FOOTER //
// ./src/containers/layout/page_top.js